import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { usePublicPaths } from '../../routes/publicPaths';

const BackButton = () => {
  const { t } = useTranslation();
  const paths = usePublicPaths();
  return (
    <div className="fixed top-6 left-6 z-[9999]">
      <Link
        to={paths.home}
        className="flex items-center bg-white/90 hover:bg-white px-4 py-2 rounded-full shadow-lg text-brand-primary hover:text-brand-primary-light transition-all duration-200 backdrop-blur-sm border border-gray-100"
      >
      <svg xmlns="http://www.w3.org/2000/svg" className="h-5 w-5 ml-1" fill="none" viewBox="0 0 24 24" stroke="currentColor">
        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M10 19l-7-7m0 0l7-7m-7 7h18" />
      </svg>
        <span className="font-medium text-sm">{t('public.common.backHome')}</span>
      </Link>
    </div>
  );
};

export default BackButton;
